import { EmployeesByDayFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

export interface Props {
  date: moment.Moment
  numberOfEmployees: number
}

class CoverageByDay {
  date: moment.Moment
  numberOfEmployees: number

  constructor(props: Props) {
    this.date = props.date.clone()
    this.numberOfEmployees = props.numberOfEmployees
  }

  static buildFromRequest(props: EmployeesByDayFragment): CoverageByDay {
    return new CoverageByDay({
      date: stringToDate(props.date, 'backend_datetime'),
      numberOfEmployees: props.numberOfEmployees,
    })
  }
}

export default CoverageByDay
